import { Heading3, MutedText } from '@/components/ui/typography';

interface EmptyStateProps {
  message: string;
  description?: string;
}

export function EmptyState({ message, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {description ? (
        <>
          <Heading3>{message}</Heading3>
          <MutedText className="mt-2 max-w-md">{description}</MutedText>
        </>
      ) : (
        <MutedText className="text-lg">{message}</MutedText>
      )}
    </div>
  );
}
